import React from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';

const SubscriptionModal = ({ closeFn, openModal, isWapView }: any) => {

    return (
        <>
            <SubscriptionModalContainer active={openModal} isWapView={isWapView}>
                <SubscriptionModalBox>
                    <SubscriptionUpper>
                        <SubscriptionInfo>Subscription Already Linked</SubscriptionInfo>
                        <SubscriptionClose className="close" onClick={closeFn}></SubscriptionClose>
                    </SubscriptionUpper>
                    <SubscriptionBottom>
                        <SubscriptionText>Your TOI+ Subscription has already been linked with your google account.</SubscriptionText>
                        <SubscriptionBtnContainer onClick={closeFn}>Continue Reading</SubscriptionBtnContainer>
                    </SubscriptionBottom>
                </SubscriptionModalBox>
            </SubscriptionModalContainer>
        </>
    )
}

export const SubscriptionModalContainer = styled.div`
    position: relative;
	display: flex;
	align-items: center;
    position: fixed;
    z-index: 1;
    bottom: -100%;
    transform: translateX(-50%);
    transition: all 0.8s ease;
    left: 50%;
    box-shadow: 0px 1px 0px 0px rgba(0,0,0,0.5);
    border-radius: 8px 8px 0 0;
    background: #fff;
    border: 1px solid #e4e4e4;
    visibility: hidden;
    ${(props: any) => props.active == true && css`
        bottom: 0;
        visibility: visible;
    `}
    ${(props: any) => props.active == true && props.isWapView == true && css`
        bottom: 50px;
        visibility: visible;
    `}
`;

export const SubscriptionUpper = styled.div`
    display: block;
`;

export const SubscriptionModalBox = styled.div`
    padding: 24px;
    border-radius: 8px 8px 0 0;
	width: 400px;
    text-align: center;
    ${(props: any) => props.active == true && props.isWapView == true && css`
        min-width: 360px;
        width: 100%;
    `}
`;



export const SubscriptionInfo = styled.div`
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 16px;
`;

export const SubscriptionClose = styled.span`
    width: 24px;
    height: 24px;
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
    &::before {
        background: #000;
        content: "";
        height: 1px;
        position: absolute;
        width: 14px;
        top: 10px;
        left: 4px;
        transform: rotate(45deg);
    }
    &::after {
        background: #000;
        content: "";
        height: 1px;
        position: absolute;
        width: 14px;
        top: 10px;
        left: 4px;
        transform: rotate(135deg);
    }
`;

export const SubscriptionBottom = styled.div`
    position: relative;
`;

export const SubscriptionText = styled.p`
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
    background: transparent;
`;

export const SubscriptionBtnContainer = styled.div`
    position: relative;
    background: #55a0ff;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border-radius: 4px;
    display: inline-block;
    padding: 8px 24px;
    color: #fff;
`;

export default SubscriptionModal;


